var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1167 0C9.07111 0 0.116699 8.95443 0.116699 20C0.116699 31.0456 9.07111 40 20.1167 40C31.1623 40 40.1167 31.0456 40.1167 20C40.1043 8.95964 31.1571 0.0123696 20.1167 0ZM20.1167 38.6667C9.80744 38.6667 1.45003 30.3092 1.45003 20C1.45003 9.69077 9.80744 1.33333 20.1167 1.33333C30.426 1.33333 38.7834 9.69077 38.7834 20C38.7717 30.3043 30.4211 38.6549 20.1167 38.6667Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4992 11.9618H14.7341C13.2075 11.9618 11.97 13.1828 11.97 14.689V25.3106C11.97 26.8168 13.2075 28.0378 14.7341 28.0378H25.4992C27.0257 28.0378 28.2633 26.8168 28.2633 25.3106V14.689C28.2633 13.1828 27.0257 11.9618 25.4992 11.9618ZM14.7341 10.6784C12.4891 10.6784 10.6692 12.474 10.6692 14.689V25.3106C10.6692 27.5256 12.4891 29.3212 14.7341 29.3212H25.4992C27.7441 29.3212 29.564 27.5256 29.564 25.3106V14.689C29.564 12.474 27.7441 10.6784 25.4992 10.6784H14.7341Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.937 20C16.937 21.7333 18.3611 23.1385 20.1179 23.1385C21.8746 23.1385 23.2987 21.7333 23.2987 20C23.2987 18.2667 21.8746 16.8615 20.1179 16.8615C18.3611 16.8615 16.937 18.2667 16.937 20ZM20.1179 15.5781C17.6427 15.5781 15.6362 17.5579 15.6362 20C15.6362 22.4421 17.6427 24.4219 20.1179 24.4219C22.593 24.4219 24.5995 22.4421 24.5995 20C24.5995 17.5579 22.593 15.5781 20.1179 15.5781Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.082 14.8355C24.082 14.224 24.5844 13.7283 25.2041 13.7283C25.8239 13.7283 26.3263 14.224 26.3263 14.8355C26.3263 15.447 25.8239 15.9427 25.2041 15.9427C24.5844 15.9427 24.082 15.447 24.082 14.8355Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.0a2de630.svg";
export { ForwardRef as ReactComponent };